// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"errorPage_notFoundContainer__2h1CF","image":"errorPage_image__IqLxX","subtitle":"errorPage_subtitle__2RuXi","contentWrapper":"errorPage_contentWrapper__3Hjvc"};